import { bl_cpcommerce_form_answer_link_RowClass } from '../../dbschema/bl_cpcommerce_form_answer_link.model';
import { BaseContainerModel } from '../base-container.model';

export class CpCommerceFormAnswerLinkContainerModel extends BaseContainerModel {
  bl_cpcommerce_form_answer_link: bl_cpcommerce_form_answer_link_RowClass = new bl_cpcommerce_form_answer_link_RowClass();
}
